import { EqxLink as Link } from '@equinoxx/react'
import React from 'react'
import generateContext from '../../hooks/GenerateContext'
import useOptionalContextState from '../../hooks/OptionalContextState'
import useScreenSize from '../../hooks/ScreenSize'
import { useEqxContinuumLayoutContext } from './EqxContinuumLayout'

const [EqxContinuumSidebarContextProvider, useSidebarContext] = generateContext(
    React.createContext<{ show: boolean; setShow: Function } | null>(null)
)
const EqxContinuumSidebarSubItem = (props: {
    title: string
    shortTitle?: string
    url: string
    badgeClassName?: string
    badgeText?: string
    icon?: string
}) => {
    return (
        <li className="nav-item">
            <Link className="nav-link link-dark" to={props.url}>
                <span className={'badge ' + (props.badgeClassName ?? 'secondary') + ' business-function-badge'}>
                    {props.icon && <span className={'business-function-icon ' + props.icon}></span>}{' '}
                    {props.badgeText ?? ''}
                </span>{' '}
                {props.title}
            </Link>
        </li>
    )
}
const EqxContinuumSidebarItem = (props: {
    title: string
    icon?: string
    iconContent?: React.ReactNode
    url: string
    menu?: React.ReactNode
    name?: string
}) => {
    const [showSubmenu, setShowSubmenu] = React.useState(false)
    const context = useSidebarContext()
    const showSidebar = context.show
    const name = props.name ?? Math.random().toString(36).substring(7)
    const menuContent = props.menu
    return (
        <li className="list-group-item">
            <Link className="link-dark" to={props.url} title={props.title}>
                <span className="tile-icon">
                    {props.iconContent ?? <span className={props.icon}></span>}
                    <span className="tile-text-tiny">{props.title}</span>
                </span>
                {menuContent ? (
                    <span
                        className="dropdown-icon d-none d-md-inline-block btn-toggle"
                        onClick={() => setShowSubmenu(!showSubmenu)}
                    >
                        <span className="dropdown-arrow fas fa-chevron-down"></span>
                    </span>
                ) : (
                    <span className="dropdown-icon d-none d-md-inline-block">
                        <span className="dropdown-spacer"></span>
                    </span>
                )}
                <span className="tile-text">{props.title}</span>
            </Link>
            {menuContent && (
                <ul
                    className={'collapse list-unstyled ' + (showSubmenu && showSidebar ? 'show' : '')}
                    role="menu"
                    id={'nav-' + name}
                >
                    {menuContent}
                </ul>
            )}
        </li>
    )
}
const EqxContinuumSidebar = (props: { children?: React.ReactNode }) => {
    const layoutContext = useEqxContinuumLayoutContext()
    const [show, setShow] = useOptionalContextState(layoutContext, 'showSidebar', false)

    const screenSize = useScreenSize()

    var originalValue = -247
    if (screenSize.isSmallerThan('sm')) {
        originalValue = -320
    }
    const left = !show ? originalValue : 0
    return (
        <EqxContinuumSidebarContextProvider value={{ show, setShow }}>
            {show && <div id="sidebar-overlay" onClick={() => setShow(false)}></div>}
            <section
                id="sidebar"
                className={show ? 'shown' : ''}
                style={{ transform: 'translateX(' + left + 'px)', transition: 'transform 0.2s' }}
                onClick={(e) => {
                    if (e.target == e.currentTarget) {
                        setShow(!show)
                    } else {
                        setShow(true)
                    }
                }}
            >
                <ul className="list-group">{props.children}</ul>
            </section>
        </EqxContinuumSidebarContextProvider>
    )
}

export { EqxContinuumSidebar as default, EqxContinuumSidebarItem, EqxContinuumSidebarSubItem }

